import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LanguageProvider } from './contexts/LanguageContext';
import LoadingScreen from './components/LoadingScreen';
import BackgroundAnimations from './components/BackgroundAnimations';
import PageTransitions from './components/PageTransitions';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Stories from './components/Stories';
import Waitlist from './components/Waitlist';
import Footer from './components/Footer';

import { initEmailJS } from './config/emailjs';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    initEmailJS();
  }, []);

  return (
    <LanguageProvider>
      <div className="App relative min-h-screen">
        <AnimatePresence mode="wait">
          {isLoading ? (
            <LoadingScreen key="loading" onComplete={() => setIsLoading(false)} />
          ) : (
            <PageTransitions key="main">
              <BackgroundAnimations />
              <div className="relative z-10">
                <Header />
                <main>
                  <Hero />
                  <About />
                  <Products />
                  <Stories />
                  <Waitlist />
                </main>
                <Footer />
              </div>
            </PageTransitions>
          )}
        </AnimatePresence>
      </div>
    </LanguageProvider>
  );
}

export default App;
